import { CustomPageConfigurationType } from '../../../../../api/custom-pages.dao';

export const reorder = <T>(list: T[], startIndex: number, endIndex: number): T[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export function getRandomInt(max): number {
    return Math.floor(Math.random() * max);
}

export const defOrderConfig = {
    Welcome: {
        order: 1,
        label: 'Welcome',
    },
    Agenda: {
        order: 2,
        label: 'My Schedule',
    },
    Session: {
        order: 3,
        label: 'General session',
    },
    Showcase: {
        order: 4,
        label: 'Showcase',
    },
    Speakers: {
        order: 5,
        label: 'Speakers',
    },
    Support: {
        order: 6,
        label: 'Support',
    },
    Replays: {
        order: 7,
        label: 'Replays',
    },
};

export const orderPages = (pages: CustomPageConfigurationType[]) => {
    const enablePageList = pages.filter(({ enabled }: CustomPageConfigurationType) => enabled);
    const disablePageList = pages.filter(({ enabled }: CustomPageConfigurationType) => !enabled);
    let maxOrderValue = Math.max(...enablePageList.map(({ order }: CustomPageConfigurationType) => Number(order)));
    const enablePages = enablePageList.map((page: CustomPageConfigurationType) => {
        let orderPage = page.order;
        if (page.order === 0) {
            maxOrderValue++;
            orderPage = maxOrderValue;
        }
        return {
            ...page,
            order: orderPage,
            label: page.label ?? defOrderConfig[page.type.toString()].label,
        };
    });

    const disablePages = disablePageList.map((page: CustomPageConfigurationType) => {
        maxOrderValue++;
        return {
            ...page,
            order: maxOrderValue,
            label: page.label ?? defOrderConfig[page.type.toString()].label,
        };
    });

    return {
        enablePages: enablePages,
        disablePages: disablePages,
        pagesList: [...enablePages, ...disablePages],
    };
};
